import { HttpResponse, ValidationUtils, ParseUtil } from '@nice-ccf/core-sdk';
import { AddressBooks, AddressBookEntriesResponse, AddressBooksEntries } from '@nice-ccf/common-sdk';

/**
 * This class to parse address book api response
 */
export class AddressBookApiParser {
  private validationUtils = new ValidationUtils();
  /**
   * This method to parse address book list
   * @param response - api response
   * @example -
   * ```
   * parseAddressBookList(response);
   * ```
   * @returns - address book list
   */
  public parseAddressBookList(response: any): Array<AddressBooks> {
    const addressBookList: AddressBooks[] = [];
    const data = response.data ? response.data : response;
    if (this.validationUtils.isNotNullOrEmpty(data) && this.validationUtils.isNotNullOrEmptyArray(data.addressBooks)) {
      data.addressBooks.forEach((addressBook: any) => {
        const addressBooks: AddressBooks = {
          addressBookName: addressBook.addressBookName,
          addressBookId: addressBook.addressBookId,
          addressBookType: addressBook.addressBookType,
        };
        if (
          addressBook?.addressBookEntries &&
          this.validationUtils.isNotNullOrEmptyArray(addressBook?.addressBookEntries)
        ) {
          addressBooks.addressBookEntries = this.formatAddressBookEntries(addressBook?.addressBookEntries);
        }
        addressBookList.push(addressBooks);
      });
    }
    return addressBookList;
  }

  /**
   * This method to parse standard address book entries
   * @param response - api response
   * @example -
   * ```
   * parseStandardAddressBookEntries(response);
   * ```
   * @returns - standard address book entries
   */
  public parseStandardAddressBookEntries(response: HttpResponse): AddressBookEntriesResponse {
    let totalRecords = 0;
    let addressBookId = '';
    let standardAddressBookEntries: AddressBooksEntries[] = [];
    if (this.validationUtils.isNotNullOrEmpty(response.data)) {
      const data = response.data;
      totalRecords = data.totalRecords;
      addressBookId = data.addressBook.addressBookId;
      if (this.validationUtils.isNotNullOrEmptyArray(data.addressBook.addressBookEntries)) {
        standardAddressBookEntries = this.formatAddressBookEntries(data.addressBook.addressBookEntries);
      }
    }
    const formattedResponse: AddressBookEntriesResponse = {
      totalRecords: totalRecords,
      addressBooksEntries: standardAddressBookEntries,
      addressBookId: ParseUtil.toNumber(addressBookId),
    };
    return formattedResponse;
  }

  /**
   * This method to formatAddressBookEntries
   * @example -
   * ```
   * formatAddressBookEntries(entries);
   * ```
   * @param entries - address book entries
   * @returns - formatted address book entries
   */
  public formatAddressBookEntries(entries: any[]): Array<AddressBooksEntries> {
    const standardAddressBookEntries: Array<AddressBooksEntries> = [];
    entries.forEach((addressBook: any) => {
      const addressBooksEntries: AddressBooksEntries = {
        firstName: addressBook.firstName,
        lastName: addressBook.lastName,
        phone: addressBook.phone,
        mobile: addressBook.mobile,
        email: addressBook.email,
        addressBookName: addressBook.firstName + ' ' + addressBook.lastName,
        addressBookEntryId: addressBook.addressBookEntryId,
        externalId: addressBook?.externalId,
        externalState: addressBook?.externalState,
        company: addressBook?.company,
        stateId: addressBook?.stateId,
        isDeleted: addressBook?.isDeleted,
      };
      standardAddressBookEntries.push(addressBooksEntries);
    });
    return standardAddressBookEntries;
  }
}
